import React from 'react' ;
import Organisation from './Organisation.react';
import SuperContractorOrganisation from './SuperContractorOrganisation.react';
import DataFeedStore from '../stores/DataFeedStore';

function getAppState() {
    return {
        isLoading: DataFeedStore.isLoading(),
        contractors: DataFeedStore.getContractors(),
        company: DataFeedStore.getOneRecord()
    };
}

var DataFeed = React.createClass({
    getInitialState: function () {
        return getAppState();
    },
    componentDidMount: function () {
        DataFeedStore.setOneRecord();
        DataFeedStore.addChangeListener(this._onChange);
    },
    componentWillReceiveProps: function () {
        this.setState(getAppState());
    },
    componentWillUnmount: function () {
        DataFeedStore.removeChangeListener(this._onChange);
    },
    render: function () {
        let organisationComponent;

        if (typeof this.state.company.record !== 'undefined') {
            if (2 === parseInt(this.state.company.level)) {
                organisationComponent = (
                    <SuperContractorOrganisation
                        contractors={this.state.contractors}
                        company={this.state.company}/>
                )
            } else {
                organisationComponent = (
                    <Organisation company={this.state.company} />
                )
            }
        } else if (!this.state.isLoading) {
            organisationComponent = (
                <div>
                    <h2>No data found</h2>
                    <br/>
                    <p><a href="/data-feed">Reload data store</a></p>
                </div>
            )
        } else {
            organisationComponent = (
                <div>
                    <h2>Loading Data . . .</h2>
                </div>
            )
        }

        return (
            <div className="DataFeed">
                {organisationComponent}
            </div>
        )
    },
    _onChange: function () {
        this.setState(getAppState());
    }
});

export default DataFeed;



// WEBPACK FOOTER //
// ./resources/assets/js/data-feed/components/DataFeed.react.js